import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/ageVerificationApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import WhiskyTemplateWidget from "../../../../components/Apps/AgeVerification/Template/WhiskyTemplateWidget";
import DefaultTemplateWidget from "../../../../components/Apps/AgeVerification/Template/DefaultTemplateWidget";
import WineTemplateWidget from "../../../../components/Apps/AgeVerification/Template/WineTemplateWidget";
import MarijuanaTemplateWidget from "../../../../components/Apps/AgeVerification/Template/MarijuanaTemplateWidget";
import BeerTemplateWidget from "../../../../components/Apps/AgeVerification/Template/BeerTemplateWidget";
import Vaping1TemplateWidget from "../../../../components/Apps/AgeVerification/Template/Vaping1TemplateWidget";

//Import Tabs
import SettingTab from "../../../../components/Apps/AgeVerification/SettingTab";
import ContentTab from "../../../../components/Apps/AgeVerification/ContentTab";
import AppearanceTab from "../../../../components/Apps/AgeVerification/AppearanceTab";

export default function CreateAgeVerification() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Settings");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Age Verification");
    const [newWidgetName, setNewWidgetName] = useState("");

    const [ageVerificationTabData, setAgeVerificationTabData] = useState({
        is_website_frontend: "",  
        minimum_age: 18,  
        verification_method: "",  
        date_format: "MM/DD/YYYY",  
        remember_visitor_days: 20,  
        action_type: "Show_Message",  
        action_message: "",  
        action_redirect_url: "",  
        display_on_pages: "Display_All_Pages",  
        hide_on_pages: "None",  
        logo: "",  
        message: "",  
        submit_button_text: "Enter",  
        yes_button_text: "Yes",  
        no_button_text: "No",  
        additional_info: "",  
        caption: "", 
        overlay_background_color: "", 
        popup_background_color: "",  
        text_color: "", 
        submit_button_color: "", 
        yes_button_color: "", 
        no_button_color: "", 
        font_type: "Default", 
        message_font: "", 
        text_font: "", 
        additional_text_font: "", 
        text_align: "Center", 
        custom_css: "",    
        custom_js: "",    
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateAgeVerificationTabData = (key, value) => {
        setAgeVerificationTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Settings", icon: "setting.png", label: "Settings" },
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Appearance", icon: "appearance.png", label: "Appearance" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setAgeVerificationTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setAgeVerificationTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(ageVerificationTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/age-verification');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/age-verification/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Settings" && (
                        <SettingTab updateAgeVerificationTabData={updateAgeVerificationTabData} ageVerificationTabData={ageVerificationTabData} />
                    )}
                    {activeSection === "Content" && (
                        <ContentTab updateAgeVerificationTabData={updateAgeVerificationTabData} ageVerificationTabData={ageVerificationTabData} />
                    )}
                    {activeSection === "Appearance" && (
                        <AppearanceTab updateAgeVerificationTabData={updateAgeVerificationTabData} ageVerificationTabData={ageVerificationTabData}/>
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/age-verification"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/age-verification/age-verification.svg`} alt="age-verification"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/age-verification/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/age-verification" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Age Verification <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Whisky_Temp" && (
                      <WhiskyTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Default_Temp" && (
                      <DefaultTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Wine_Temp" && (
                      <WineTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Marijuana_Temp" && (
                      <MarijuanaTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Beer_Temp" && (
                      <BeerTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Vaping_1_Temp" && (
                      <Vaping1TemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 